import { graphql, useStaticQuery } from 'gatsby';

export const useGCMSLevel = () => {
  const data = useStaticQuery(graphql`
    {
      levels: allGoogleSpreadsheetDolLandingPageMarLevelData {
        group(field: level, limit: 1) {
          nodes {
            level
            levelTotalHour
          }
        }
      }
    }
  `);
  return {
    levelToHour: data.levels.group
      .map(group => group.nodes[0])
      .reduce(
        (current, { level, levelTotalHour }) => ({
          ...current,
          [level]: levelTotalHour
        }),
        {}
      )
  };
};
